
    import {toRefs, reactive, watch} from 'vue'

    export default {
        name: "infoList",
        props: {
            dataList: {
                type: Array,
                default: () => {
                    return []
                }
            },
            labelWidth: {
                type: String,
                default: '100%'
            },
            valueWidth: {
                type: String,
                default: '100%'
            },
            direction: {
                type: Boolean,
                default: false
            }
        },
        setup(props: any) {
            let state = reactive({
                dataList: []
            })
            watch(props, () => {
                const {dataList} = toRefs(props)
                state.dataList = dataList.value
            })
            return {
                state
            }
        }
    }
